import { Component, ChangeDetectionStrategy, inject } from '@angular/core';

import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { DmsBaseFolderAction } from '../dms-base-folder-action';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-copy-folder-button',
  templateUrl: './dms-copy-folder-button.component.html',
  styleUrls: ['./dms-copy-folder-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
})
export class IrisDmsCopyFolderButtonComponent extends DmsBaseFolderAction {
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);

  protected _label = 'label.dms.CopyToFolder';

  public openCopyFolderModal(): void {
    this.dmsModalsSandbox.showCopyFolderModal(this.folderId());
  }
}
